import React, { useId } from "react";
import { TotoAdaptiveDock, SCHEDULING_DESTINATIONS } from "../toto/TotoAdaptiveSurface";
import "./request-vessels.css";

export default function RequestVessel({ title, description, swap, toolbar, children }) {
  return <main className={`toto-workspaces request-vessel ${swap ? "request-vessel--swap" : ""}`}>
    <section className="request-vessel__surface scheduling-vessel__surface" aria-labelledby="request-vessel-title">
      <header className="request-vessel__header"><div><p className="request-eyebrow">MY REQUESTS</p><h1 id="request-vessel-title">{title}</h1><p>{description}</p></div>
        <img src="/brand/toto-canonical/original-gold.png" alt="TOTO with original gold badge" width="100" height="100" />
      </header>
      <div className="request-navigation-bar" data-vessel-page-navigation>{toolbar && <div className="request-navigation-bar__actions">{toolbar}</div>}</div>
      <div className="request-vessel__content">{children}</div>
    </section><TotoAdaptiveDock active="workspace" destinations={swap ? SCHEDULING_DESTINATIONS.map(item => ({ ...item, selected: item.id === "swaps" })) : undefined} />
  </main>;
}
export function RequestCard({ title, icon, color = "yellow", children, className = "" }) {
  return <section className={`request-card ${className}`}>
    {title && <div className="request-card__heading">{icon && <span className={`request-pop request-pop--${color}`} aria-hidden="true">{icon}</span>}<h2>{title}</h2></div>}{children}
  </section>;
}
export function RequestField({ label, children, hint }) {
  const uniqueId = useId();
  const inputId = children.props.id || uniqueId;
  const hintId = `${uniqueId}-hint`;
  return <div className="request-field"><label htmlFor={inputId}>{label}</label>{React.cloneElement(children, { id: inputId, "aria-describedby": hint ? hintId : children.props["aria-describedby"] })}{hint && <small id={hintId}>{hint}</small>}</div>;
}
export function RequestError({ message, errorRef }) {
  return message ? <p className="request-message" role="alert" tabIndex={-1} ref={errorRef}>{message}</p> : null;
}
